<template>
  <div>
    <div class="modal_text_wrap">
      <button @click="isVisible = !isVisible" class="modal_text">
        車種を変更する
      </button>
    </div>

    <div id="overlay" v-if="isVisible">
      <div id="content">
        <div class="flex_flex-col_items-center">
          <div>
            <p class="text-center_pt-11">
              選択中のコンフィギュレーターの<br />情報はリセットされます。<br />よろしければ「はい」を選択してください。
            </p>
          </div>
          <div class="flex_gap-9_pt-12">
            <router-link :to="{ name: 'car_lineup' }">
              <button class="modal_btn" @click="isVisible = !isVisible">はい</button>
            </router-link>
            <button class="modal_btn" @click="isVisible = !isVisible">いいえ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const isVisible = ref(false);
    return {
      isVisible,
    };
  },
};
</script>

<style scoped>
.modal_btn {
  color: #000;
}
</style>
